import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { trackPageView } from "./lib/analytics";
import Home from "./pages/Home";
import Success from "./pages/Success";
import { AvisoLegal, Privacidad, Terminos, Cookies } from "./pages/Legal";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/sonner";

function PageViewTracker() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/success" element={<Success />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="/cookies" element={<Cookies />} />
        </Routes>
        <CookieBanner />
        <PageViewTracker />
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
